import React, { useState, useEffect } from "react";
import BarclaysLogo from "../../assets/logo/Barclays-Logo.wine.svg";
import HsbcLogo from "../../assets/logo/HSBC-Logo.wine.svg";
import RevolutLogo from "../../assets/logo/revolut-business-bank.svg";
import MonzoLogo from "../../assets/logo/monzo-new.png";
import TideLogo from "../../assets/logo/tide-business-bank.png";
import {
	Box,
	Button,
	Typography,
	FormControlLabel,
	Radio,
	Grid,
} from "@mui/material";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { RadioGroup } from "@mui/material";
import {
	BankingDetailsApi,
	getBankingDetailsApi,
	editBankingDetailsApi,
} from "../../apiServices/services/DocumentsServices";
import { updateFormStatus } from "../../apiServices/services/ProfileServices";
import CompletionTick from "../../assets/logo/completionTick.svg";

const highStreetBanks = [
	{
		id: 1,
		logo: BarclaysLogo,
		width: "180px",
		objectFit: "fill",
		name: "barclays",
		title: "Barclays Business Bank",
		desc: "We've partnered with some of the UKs leading Business Banks to streamline the process and get you access to the best discounts available",
	},
	{
		id: 2,
		logo: HsbcLogo,
		width: "180px",
		objectFit: "fill",
		name: "hsbc",
		title: "HSBC Business Bank",
		desc: "We've partnered with some of the UKs leading Business Banks to streamline the process and get you access to the best discounts available",
	},
];

const neoBanks = [
	{
		id: 1,
		logo: TideLogo,
		width: "100px",
		objectFit: "fill",
		name: "tide",
		title: "Tide Business Bank",
		desc: "We've partnered with some of the UKs leading Business Banks to streamline the process and get you access to the best discounts available",
	},
	{
		id: 2,
		logo: MonzoLogo,
		width: "100px",
		name: "monzo",
		title: "Monzo Business Bank",
		objectFit: "contain",
		desc: "We've partnered with some of the UKs leading Business Banks to streamline the process and get you access to the best discounts available",
	},
	{
		id: 3,
		logo: RevolutLogo,
		width: "100px",
		name: "revolut",
		title: "Revolut Business Bank",
		objectFit: "fill",
		desc: "We've partnered with some of the UKs leading Business Banks to streamline the process and get you access to the best discounts available",
	},
];

const BANK_MAP = {
	barclays: "isisBarclays",
	hsbc: "isHsbc",

	tide: "isTide",
	monzo: "isMonzo",
	revolut: "isRevolut",
};

const Banking = ({ onContinue, onBack }) => {
	const [formData, setFormData] = useState({
		isisBarclays: false,
		isHsbc: false,

		isTide: false,
		isMonzo: false,
		isRevolut: false,

		isContactBankRequired: false,
		isFormCompleted: false,
		userId: localStorage.getItem("userId"),
	});

	const [userId, setUserId] = useState(0);

	useEffect(() => {
		getBankingDetailsApi(formData.userId).then((response) => {
			if (response?.attributes?.results[0]) {
				setUserId(response?.attributes?.results[0].id);
				setFormData((prevState) => ({
					...prevState,
					isisBarclays: response?.attributes?.results[0].isisBarclays,
					isHsbc: response?.attributes?.results[0].isHsbc,

					isTide: response?.attributes?.results[0].isTide,
					isMonzo: response?.attributes?.results[0].isMonzo,
					isRevolut: response?.attributes?.results[0].isRevolut,
					isFormCompleted:
						response?.attributes?.results[0].isFormCompleted,
				}));
			} else if (!response?.attributes.results[0]) {
				setFormData((prevState) => ({
					...prevState,
					isisBarclays: true,
					isTide: true,
				}));
			}
		});
	}, []);

	const handleSubmit = () => {
		const { isisBarclays, isHsbc, isTide, isMonzo, isRevolut } = formData;

		if (!isisBarclays && !isHsbc) {
			alert("Select one high-street bank");
			return;
		}
		if (!isTide && !isMonzo && !isRevolut) {
			alert("Select one neo business bank");
			return;
		}

		if (!formData.isFormCompleted) {
			BankingDetailsApi({ ...formData, isFormCompleted: true }).then(
				(res) => {
					if (res.status === 200) {
						updateFormStatus(formData.userId, {
							isBankingDetailsCompleted: true,
						}).then((res) => {
							if (res.status === 200) {
								onContinue();
								localStorage.setItem(
									"activeForm",
									"isBankingDetailsCompleted"
								);
							} else {
							}
						});
					}
				}
			);
		} else {
			editBankingDetailsApi(userId, { ...formData }).then((res) => {
				if (res.status === 200) {
					onContinue();
					localStorage.setItem(
						"activeForm",
						"isBankingDetailsCompleted"
					);
				}
			});
		}
	};

	const handleClick = (bank, type) => {
		if (type === "high-street") {
			setFormData((prevData) => ({
				...prevData,
				isisBarclays: bank === "barclays",
				isHsbc: bank === "hsbc",
			}));
		} else if (type === "neo") {
			setFormData((prevData) => ({
				...prevData,
				isTide: bank === "tide",
				isRevolut: bank === "revolut",
				isMonzo: bank === "monzo",
			}));
		}
	};

	return (
		<Box
			sx={{
				width: "90%",
				padding: 4,
				backgroundColor: "#fff",
				borderRadius: 2,
				// margin: "auto",
			}}>
			<Typography
				variant='h6'
				sx={{
					color: "1C2434",
					fontWeight: "900",
					fontSize: "1.25rem",
				}}>
				Set up your Business Bank Account
			</Typography>
			<Typography
				variant='body1'
				sx={{
					fontWeight: "medium",
					fontSize: "1rem",
					color: "2F2D3B",
					mb: 3,
					mt: 2,
					maxWidth: "750px",
					width: "100%",
				}}>
				To safeguard your business, we recommend that you set up 2
				different Bank Accounts to spread your money and derisk yourself
				from any potential situation in the future.
			</Typography>
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",

					gap: "2rem",
				}}>
				<RadioGroup
					sx={{
						background: "#F7F6F6",
						padding: "1rem",
						borderRadius: "0.5rem",
					}}
					onChange={(e) =>
						handleClick(e.target.value, "high-street")
					}>
					<Typography
						variant='body1'
						sx={{
							fontWeight: "medium",
							fontSize: "1.25rem",
							color: "2F2D3B",
							mb: 3,
						}}>
						<strong>Select One</strong> High-street Business Bank
						Account
					</Typography>

					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							gap: "1rem",
						}}>
						{highStreetBanks.map(
							({
								id,
								logo,
								width,
								name,
								title,
								desc,
								objectFit,
							}) => {
								const isChecked = formData[BANK_MAP[name]];
								return (
									<Box
										key={id}
										sx={{
											padding: 4,
											backgroundColor: "#fff",
											borderRadius: 2,
											boxShadow: 1,
											cursor: "pointer",
										}}
										onClick={() =>
											handleClick(name, "high-street")
										}>
										<Box
											sx={{
												display: "flex",
												alignItems: "center",
												gap: "3rem",
											}}>
											<Box
												sx={{
													display: "flex",
													justifyContent: "center",
													alignItems: "center",
												}}>
												<FormControlLabel
													control={
														<Radio
															checked={isChecked}
															value={name}
															sx={{
																transform:
																	"scale(1.5)",
															}}
															icon={
																<RadioButtonUncheckedIcon
																	sx={{
																		fontSize: 20,
																	}}
																/>
															}
															checkedIcon={
																<Box>
																	<img
																		width={
																			"20px"
																		}
																		style={{
																			marginRight:
																				"7px",
																		}}
																		alt='radio tick'
																		src={
																			CompletionTick
																		}
																	/>
																</Box>
															}
														/>
													}
													label=''
												/>
											</Box>
											<Box>
												<img
													width={width}
													src={logo}
													alt='logo'
													style={{
														objectFit,
													}}
												/>
											</Box>
											<Box>
												<Typography
													variant='h6'
													sx={{
														color: "#1C2434",
														fontWeight: "bold",
														fontSize: "1.25rem",
													}}>
													{title}
												</Typography>
												<Typography
													variant='body1'
													sx={{
														fontWeight: "medium",
														fontSize: "1rem",
														color: "#2F2D3B",
														mb: 3,
														mt: 2,
													}}>
													{desc}
												</Typography>
											</Box>
										</Box>
									</Box>
								);
							}
						)}
					</Box>
				</RadioGroup>

				<RadioGroup
					sx={{
						background: "#F7F6F6",
						padding: "1rem",
						borderRadius: "0.5rem",
					}}
					onChange={(e) => handleClick(e.target.value, "neo")}>
					<Typography
						variant='body1'
						sx={{
							fontWeight: "medium",
							fontSize: "1.25rem",
							color: "2F2D3B",
							mb: 3,
						}}>
						<strong>Select One</strong> NEO Business Bank Account
					</Typography>
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							gap: "1rem",
						}}>
						{neoBanks.map(
							({
								id,
								logo,
								width,
								name,
								title,
								desc,
								objectFit,
							}) => {
								const isChecked = formData[BANK_MAP[name]];
								return (
									<Box
										key={id}
										sx={{
											padding: 4,
											backgroundColor: "#fff",
											borderRadius: 2,
											boxShadow: 1,
											cursor: "pointer",
										}}
										onClick={() =>
											handleClick(name, "neo")
										}>
										<Box
											sx={{
												display: "flex",
												alignItems: "center",
												gap: "5rem",
											}}>
											<Box
												sx={{
													display: "flex",
													justifyContent: "center",
													alignItems: "center",
												}}>
												<FormControlLabel
													control={
														<Radio
															checked={isChecked}
															value={name}
															sx={{
																transform:
																	"scale(1.5)",
															}}
															icon={
																<RadioButtonUncheckedIcon
																	sx={{
																		fontSize: 20,
																	}}
																/>
															}
															checkedIcon={
																<Box>
																	<img
																		width={
																			"20px"
																		}
																		style={{
																			marginRight:
																				"7px",
																		}}
																		alt='radio tick'
																		src={
																			CompletionTick
																		}
																	/>
																</Box>
															}
														/>
													}
													label=''
												/>
											</Box>
											<Box>
												<img
													width={width}
													src={logo}
													alt='logo'
													style={{
														objectFit,
													}}
												/>
											</Box>
											<Box>
												<Typography
													variant='h6'
													sx={{
														color: "#1C2434",
														fontWeight: "bold",
														fontSize: "1.25rem",
													}}>
													{title}
												</Typography>
												<Typography
													variant='body1'
													sx={{
														fontWeight: "medium",
														fontSize: "1rem",
														color: "#2F2D3B",
														mb: 3,
														mt: 2,
													}}>
													{desc}
												</Typography>
											</Box>
										</Box>
									</Box>
								);
							}
						)}
					</Box>
				</RadioGroup>
			</Box>
			<Grid item xs={12}>
				<Box mt={2} display='flex'>
					<Button
						sx={{
							marginTop: "1rem",
							textTransform: "none",
							backgroundColor: "#ffffff",
							color: "#cfcfcf",
							border: "1px solid #cfcfcf",
							borderRadius: "1rem",
							padding: "0.4rem 1.5rem",
							fontWeight: 600,
							"&:hover": {
								color: "#2069F8",
								border: "1px solid #2069F8",
							},
						}}
						onClick={onBack}>
						Previous
					</Button>
					<Button
						sx={{
							marginTop: "1rem",
							marginLeft: "0.5rem",
							borderRadius: "1rem",
							backgroundColor: "#2069F8",
							color: "#ffffff",
							fontWeight: 700,
							padding: "0.5rem 1.5rem",
							textTransform: "none",
							width: "max-content",
							"&:hover": {
								backgroundColor: "#2069F8",
							},
						}}
						onClick={handleSubmit}>
						Continue
					</Button>
				</Box>
			</Grid>
		</Box>
	);
};

export default Banking;
